import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";
import budapestAirport from "@/assets/partners/budapest-airport.png";
import skyway from "@/assets/partners/skyway.webp";
import affinity from "@/assets/partners/affinity.png";
import bauunternehmung from "@/assets/partners/bauunternehmung.webp";
import aeroportoBologna from "@/assets/partners/aeroporto-bologna.png";
import unicoopFirenze from "@/assets/partners/unicoop-firenze.png";
import avolta from "@/assets/partners/avolta.png";
import autogrill from "@/assets/partners/autogrill.png";
import agos from "@/assets/partners/agos.png";
import veneziaAirport from "@/assets/partners/venezia-airport.png";
import toscanaAeroporti from "@/assets/partners/toscana-aeroporti.png";
import aena from "@/assets/partners/aena.png";
import svicom from "@/assets/partners/svicom.webp";
import seaMilanAirports from "@/assets/partners/sea-milan-airports.svg";
import accenture from "@/assets/partners/accenture.png";
import dubrovnikAirport from "@/assets/partners/dubrovnik-airport.png";
import michelin from "@/assets/partners/michelin.webp";
import google from "@/assets/partners/google.png";
import expo2025 from "@/assets/partners/expo-2025.png";

const partnerLogos = [
  { name: "Budapest Airport", logo: budapestAirport },
  { name: "Skyway Monte Bianco", logo: skyway },
  { name: "Affinity Petcare", logo: affinity },
  { name: "Bauunternehmung", logo: bauunternehmung },
  { name: "Aeroporto di Bologna", logo: aeroportoBologna },
  { name: "Unicoop Firenze", logo: unicoopFirenze },
  { name: "Avolta", logo: avolta },
  { name: "Autogrill", logo: autogrill },
  { name: "Agos", logo: agos },
  { name: "Venezia Airport", logo: veneziaAirport },
  { name: "Toscana Aeroporti", logo: toscanaAeroporti },
  { name: "Aena", logo: aena },
  { name: "Svicom", logo: svicom },
  { name: "SEA Milan Airports", logo: seaMilanAirports },
  { name: "Accenture", logo: accenture },
  { name: "Dubrovnik Airport", logo: dubrovnikAirport },
  { name: "Michelin", logo: michelin },
  { name: "Google", logo: google },
  { name: "Expo 2025 Osaka", logo: expo2025 },
];

export const PartnerStrip = () => {
  const { t } = useLanguage();


  return (
    <section id="partners" className="py-12 bg-card border-y border-border/50 overflow-hidden scroll-mt-20">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8"
        >
          <p className="font-medium text-muted-foreground uppercase tracking-wider mb-2 text-base">
            {t.partners.title}
          </p>
          <p className="text-muted-foreground/80 max-w-xl mx-auto text-sm px-px">
            {t.partners.subtitle}
          </p>
        </motion.div>

        <div className="relative w-full overflow-hidden">
          {/* Gradient fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-r from-card to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-l from-card to-transparent z-10 pointer-events-none" />
          
          {/* Marquee - singolo container con due set di loghi */}
          <div className="marquee-track flex hover:[animation-play-state:paused]">
            {/* Primo set */}
            {partnerLogos.map((partner, index) => (
              <div
                key={`a-${index}`}
                className="flex-shrink-0 flex items-center justify-center h-20 sm:h-24 px-6 sm:px-10 transition-opacity duration-300 opacity-80 hover:opacity-100"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-10 sm:max-h-14 w-auto object-contain"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
            {/* Secondo set identico per loop continuo */}
            {partnerLogos.map((partner, index) => (
              <div
                key={`b-${index}`}
                className="flex-shrink-0 flex items-center justify-center h-20 sm:h-24 px-6 sm:px-10 transition-opacity duration-300 opacity-80 hover:opacity-100"
                aria-hidden="true"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-10 sm:max-h-14 w-auto object-contain"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
